<template>
  <el-dialog v-el-drag-dialog
             :visible.sync="dialogVisible"
             :close-on-click-modal="false"
             title="打印客诉申请单"
             width="1000px">
    <div style="width: 900px;" id="printCsmContent">
      <div id="printCards">
        <table style="width: 100%;margin-top: 10px;" cellpadding="0" cellspacing="0">
          <tr>
            <td colspan="4" style="text-align: center;">
              <span style="font-size: 20px;font-weight: bold;">客诉申请单</span></td>
          </tr>
          <tr>
            <td>编号：{{ replacementBill.billNo }}</td>
            <td>公司：{{ replacementBill.factoryNo }}</td>
            <td>生产地：{{ replacementBill.problemAddress }}</td>
            <td>客户名称：{{ replacementBill.customerName }}</td>
          </tr>
          <tr>
            <td>销售订单编号：{{ replacementBill.salesOrderNo }}</td>
<!--            <td>状态：{{ replacementBill.serviceType }}</td>-->
            <td>状态：{{ replacementBill.statusName }}</td>
            <td>制单人：{{ replacementBill.creatorName }}</td>
            <td>制单时间：{{ replacementBill.createTime }}</td>
          </tr>
          <tr>
            <td colspan="4">备注:{{ replacementBill.note }}</td>
          </tr>
        </table>
        <el-table style="margin-top: 10px;"
            class="tableBox"
            :data="replacementBill.details"
            :cell-style="{border: '0.5px solid #111'}"
            :header-cell-style="{border: '1px solid #111'}"
            stripe>
          <el-table-column prop="materialNo" align="left" label="物料编号"/>
          <el-table-column prop="materialName" align="left" label="物料名称"/>
          <el-table-column prop="specification" align="center" label="规格型号"/>
          <el-table-column prop="quantity" align="center" label="数量"/>
          <el-table-column prop="deliveryDate" label="出货日期" align="center"/>
          <el-table-column prop="badQuantity" align="center" label="异常数量"/>
          <el-table-column prop="materialType" align="center" label="产品类型"/>
          <el-table-column prop="returnProd" align="center" label="是否退货"/>
          <el-table-column prop="returnDate" label="退回时间" align="center"/>
          <el-table-column prop="problemDesc" align="center" label="备注"/>
        </el-table>
<!--        解决方案-->
        <table style="width: 100%;margin-top: 15px;" cellpadding="0" cellspacing="0">
          <tr>
            <td colspan="2">临时解决方案：{{ replacementBill.problemSolution }}</td>
            <td colspan="2">最终责任判断：{{ replacementBill.finalConclusion }}</td>
          </tr>
          <tr>
            <td>责任部门：{{ replacementBill.improvementDepartment }}</td>
            <td>库存盘查：{{ replacementBill.productInformation }}</td>
            <td>填写损失：{{ replacementBill.comment }}</td>
            <td>任务编号：{{ replacementBill.serviceType }}</td>
          </tr>
        </table>
        <el-table :data="listSolution1_0" style="margin-top: 5px;">
          <el-table-column prop="solutionType" label="产品状态分布(围堵措施)"  align="center" width="150"/>
          <el-table-column prop="quantity" align="center" label="数量"/>
          <el-table-column prop="solution" align="center" label="处理方案"/>
          <el-table-column prop="feedBack" align="center" label="处理结果" width="100"/>
          <el-table-column prop="solutionHandler" align="center" label="责任人" width="100"/>
          <el-table-column prop="fileName" align="center" label="附件" width="180"/>
          <el-table-column prop="completionTimePlan" label="出货日期" align="center" width="160"/>
<!--          <el-table-column prop="note" align="center" label="说明文字" width="200"/>-->
        </el-table>
        <el-table :data="listSolution2" style="margin-top: 5px;">
          <el-table-column prop="solutionType" align="center" width="160"/>
          <el-table-column prop="solution" align="center" label="根本原因分析"/>
          <el-table-column prop="fileName" align="center" label="附件" width="300"/>
          <el-table-column prop="note" align="center" label="说明文字" width="200"/>
        </el-table>
        <el-table :data="listSolution3" style="margin-top: 5px;">
          <el-table-column prop="solutionType" align="center" width="160"/>
          <el-table-column prop="solution" align="center"/>
        </el-table>
        <el-table :data="listSolution4" style="margin-top: 5px;">
          <el-table-column prop="solutionType" align="center" width="160"/>
          <el-table-column prop="solution" align="center" label="永久纠正错误及执行"/>
          <el-table-column prop="fileName" align="center" label="附件" width="300"/>
          <el-table-column prop="note" align="center" label="说明文字" width="200"/>
        </el-table>
        <el-table :data="listSolution5" style="margin-top: 5px;">
          <el-table-column prop="solutionType" align="center" width="160"/>
          <el-table-column prop="solution" align="center" label="预防再发生"/>
          <el-table-column prop="note" align="center" label="说明文字" width="200"/>
        </el-table>
        <el-table :data="listSolution6" style="margin-top: 5px;">
          <el-table-column prop="solutionType" align="center" width="160"/>
          <el-table-column prop="solution" align="center" label="文件"/>
          <el-table-column prop="solutionHandler" align="center" label="负责人" width="100"/>
          <el-table-column prop="completionTimePlan" align="center" label="完成日期" width="150"/>
          <el-table-column prop="fileNo" align="center" label="文件编号" width="100"/>
          <el-table-column prop="qmConfirm" align="center" label="说明文字" width="200"/>
        </el-table>

        <table style="width: 100%;margin-top: 10px;" cellpadding="0" cellspacing="0">
          <tr>
            <td>节点</td>
            <td>处理人</td>
            <td>处理意见</td>
            <td>处理结果</td>
            <td>处理时间</td>
            <td>到达时间</td>
          </tr>
          <tr v-for="(item) in model.handleDetailVos">
            <td>{{item.nodeText}}</td>
            <td>{{item.handlerName}}</td>
            <td>{{item.handleRemark}}</td>
            <td>{{item.handleResultText}}</td>
            <td>{{item.handleTime}}</td>
            <td>{{item.createdTime}}</td>
          </tr>
        </table>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" v-print="printOption" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  data() {
    return {
      dialogVisible: false,
      ids: [],
      billType:14,
      printOption: {
        id: "printCsmContent",
        preview: false,
        popTitle: "打印",
        previewPrintBtnLabel: "打印",
        clickMounted() {
        },
      },
      model: {
        handleDetailVos: [],
      },
      replacementBill: {
        pkId: 0,
        billNo: "",
        customerId: 0,
        customerName: "",
        salesOrderNo: "",
        problemAddress: "上海",
        factoryNo: "",
        status: "",
        statusName: "",
        creatorName: "",
        createTime: "",
        note: "",
        problemSolution: "",
        productInformation: "",
        finalConclusion: "",
        improvementDepartment: "",
        details: [],
        attachments: [],
        solutions: [],
      },
      listSolution1_0: [],
      listSolution1_1: [],
      listSolution1_2: [],
      listSolution1_3: [],
      listSolution1_4: [],
      listSolution2: [],
      listSolution3: [],
      listSolution4: [],
      listSolution5: [],
      listSolution6: [],
      solution1_0: {
        rowIndex: 1,
        solutionType: "在生产",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution1_1: {
        rowIndex: 2,
        solutionType: "库存",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution1_2: {
        rowIndex: 3,
        solutionType: "运输途中",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution1_3: {
        rowIndex: 4,
        solutionType: "已出货",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution1_4: {
        rowIndex: 5,
        solutionType: "受影响的其它材料",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution2: {
        rowIndex: 2,
        solutionType: "根本原因分析",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution3: {
        rowIndex: 3,
        solutionType: "指定临时对策",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution4: {
        rowIndex: 4,
        solutionType: "永久纠正错误及执行",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution5: {
        rowIndex: 5,
        solutionType: "预防再发生",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution6: {
        rowIndex: 6,
        solutionType: "涉及时，更新这些项目反映更改内容",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
    };
  },
  methods: {
    open(replacementBill) {
      this.replacementBill.pkId = replacementBill.pkId;
      // this.replacementBill = JSON.parse(JSON.stringify(replacementBill));
      this.dialogVisible = true;
      this.getData();
      this.getWfData();
    },

    // 根据id查询详细信息
    getData() {
      this.contentLoading = true;
      this.listSolution1_0 = [];
      this.listSolution1_1 = [];
      this.listSolution1_2 = [];
      this.listSolution1_3 = [];
      this.listSolution1_4 = [];
      this.listSolution2 = [];
      this.listSolution3 = [];
      this.listSolution4 = [];
      this.listSolution5 = [];
      this.listSolution6 = [];
      this.listSolution1_0.push(this.solution1_0);
      this.listSolution1_1.push(this.solution1_1);
      this.listSolution1_2.push(this.solution1_2);
      this.listSolution1_3.push(this.solution1_3);
      this.listSolution1_4.push(this.solution1_4);
      this.listSolution2.push(this.solution2);
      this.listSolution3.push(this.solution3);
      this.listSolution4.push(this.solution4);
      this.listSolution5.push(this.solution5);
      this.listSolution6.push(this.solution6);
      this.$http
          .get("basic", `replacementBills/${this.replacementBill.pkId}`)
          .then((resp) => {
            if (resp.success) {
              this.replacementBill = Object.assign(this.replacementBill, resp.data);
              if (this.replacementBill.statusName == "通过") {
                this.showSolution = true;
              } else {
                this.showSolution = false;
              }
              if (this.replacementBill.solutions.length > 0) {
                this.updateSolution(this.listSolution1_0, this.replacementBill.solutions[0]);
                this.updateSolution(this.listSolution1_1, this.replacementBill.solutions[1]);
                this.updateSolution(this.listSolution1_2, this.replacementBill.solutions[2]);
                this.updateSolution(this.listSolution1_3, this.replacementBill.solutions[3]);
                this.updateSolution(this.listSolution1_4, this.replacementBill.solutions[4]);
                this.updateSolution(this.listSolution2, this.replacementBill.solutions[5]);
                this.updateSolution(this.listSolution3, this.replacementBill.solutions[6]);
                this.updateSolution(this.listSolution4, this.replacementBill.solutions[7]);
                this.updateSolution(this.listSolution5, this.replacementBill.solutions[8]);
                this.updateSolution(this.listSolution6, this.replacementBill.solutions[9]);

                this.listSolution1_0.push(this.listSolution1_1[0]);
                this.listSolution1_0.push(this.listSolution1_2[0]);
                this.listSolution1_0.push(this.listSolution1_3[0]);
                this.listSolution1_0.push(this.listSolution1_4[0]);
              }

              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
    },

    //待办明细
    getWfData(){
      this.$http.get("basic", `applications/handle-detail/${this.billType}/${this.replacementBill.pkId}`).then((resp) => {
        this.model = resp.data;
        console.log(this.model);
      });
    },

    updateSolution(listSolution, solution) {
      listSolution.forEach((item) => {
        item.productStatus = solution.productStatus;
        item.quantity = solution.quantity;
        item.solution = solution.solution;
        item.feedBack = solution.feedBack;
        item.solutionHandler = solution.solutionHandler;
        item.completionTimePlan = solution.completionTimePlan;
        item.filePath = solution.filePath;
        item.fileName = solution.fileName;
        item.fileNo = solution.fileNo;
        item.qmConfirm = solution.qmConfirm;
        item.note = solution.note;
      });
    },

    print() {
      // this.$http.get("basic", `taskDispatchBills/updatePrint/${this.ids}`).then(() => {
      // });
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
#printCards {
  margin: 0 auto;
  margin-top: 1.5mm;
  page-break-before: always;
  font-size: 10px;

  //.el-table--border {
  //  border: 1px solid black;
  //}

  .el-table__body td {
    border: 1px solid black;
  }

  .el-table__header th {
    border: 1px solid black;
  }

  table {
    width: 100%;
    height: 100%;

    td {
      border: 1px solid #111;
      border-right: 0;
      border-bottom: 0;
      padding: 5px 5px;
      box-sizing: border-box;
      font-size: 10px;
      //min-width: 140px;
      white-space: pre-wrap;
    }

    tr {
      width: 700px;
    }

    tr td:last-child {
      border-right: 1px solid #111;
    }

    tr:last-child td {
      border-bottom: 1px solid #111;
    }
  }
}

@media print {
  table {
    td {
      word-break: break-all;
    }
  }
}
</style>
